import React from "react";
import { Card, CardBody, Col, Container, Row, Button } from "reactstrap";
import Header from "components/Headers/Header";
import { useSelector } from "react-redux";

function Ambassador4Brand() {
  const { uid } = useSelector((state) => state.auth);

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          <div className="bg-gradient-primary p-4 text-white">
            <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
              ATHLETE PARTNERSHIPS
            </span>
            <h2 className="text-white mb-0 mt-1 font-weight-700">
              Ambassador<span className="text-info">4</span><span className="text-danger">Brand</span>
            </h2>
          </div>
          
          <CardBody className="p-4 bg-secondary">
            <Row className="justify-content-center">
              <Col lg="10" xl="8">
                <div className="bg-white p-4 rounded-4 shadow-sm mb-4">
                  <h3 className="h4 text-dark mb-3 font-weight-bold">
                    Connect, Teach, and Earn
                  </h3>
                  <p className="text-muted" style={{ fontSize: "1rem", lineHeight: "1.6" }}>
                    <strong>Ambassador4Brand</strong> is where Student Athletes link up with Fans to say Hello by WhatsApp and Zoom, and schedule a chat or training session for the Fan online. 
                  </p>
                  <p className="text-muted" style={{ fontSize: "1rem", lineHeight: "1.6" }}>
                    That’s how Student Athlete Brand Ambassadors earn a little extra money—by teaching Fans online how the websites of the FHP Brand work, step by step.
                  </p>
                </div>

                <div className="row justify-content-center" style={{ gap: "20px" }}>
                  <Col md="5" className="bg-white p-3 rounded-3 shadow-sm mb-3" style={{ borderLeft: "4px solid #5e72e4" }}>
                    <h5 className="font-weight-700 text-dark mb-2">
                      <i className="fas fa-video text-primary mr-2"></i> WhatsApp & Zoom Calls
                    </h5>
                    <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                      Easily schedule chats or training sessions with your supporters.
                    </p>
                  </Col>
                  <Col md="5" className="bg-white p-3 rounded-3 shadow-sm mb-3" style={{ borderLeft: "4px solid #2dce89" }}>
                    <h5 className="font-weight-700 text-dark mb-2">
                      <i className="fas fa-dollar-sign text-success mr-2"></i> Earn Extra Income
                    </h5>
                    <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                      Earn money by showing fans how to navigate and make the most of the FHP network.
                    </p>
                  </Col>
                </div>

                <div className="text-center mt-4">
                  <a 
                    href={`https://athlete-for-brand.web.app/?athleteId=${uid}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <Button color="primary" size="lg" className="rounded-pill px-5 shadow font-weight-bold">
                      <i className="fas fa-external-link-alt mr-2"></i> Open Ambassador4Brand Portal
                    </Button>
                  </a>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default Ambassador4Brand;
